import Param from '../../param';

const param = new Param();

/* ---------------------------------------

    -- 要素の表示、非表示を管理

--------------------------------------- */
export default class Contents{
    constructor(){

        this.$root;

        this.$scrollDown;
        this.$pageTop;
        this.$sideBtn;

        // this.$headNavi =  document.getElementById("l-header-navi").children[0];
        // this.$headBtn =  document.getElementById("l-header-btn");
        this.$topKvSns;

        this.$header;
        this.$footer;
        this.offset = {
            pagetop : {
                start : 0,
                end   : 0
            },
            scrollDown : 0,
        }

        this.status = {
            pagetop    : false,
            scrollDown : true,
            sideBtn : true,
        };

        this.h = 0;


    }
    init(){

        this.$root = document.getElementById("l-root");

        this.$scrollDown = document.getElementById("c-scrolldown");
        this.$pageTop =  document.getElementById("c-pagetop");
        this.$header = document.getElementById("l-header");
        this.$footer = document.getElementById("l-footer");
        this.$sideBtn = document.getElementById("c-sidebtn");

        this.$topKvSns = document.getElementById("p-top-kv-sns");

        this.status = {
            pagetop    : false,
            scrollDown : true,
            sideBtn : true,
        }
        TweenMax.set(this.$pageTop,{
            x:100
        });
    }
    update(inc,pageID,bannerShow){

        if(pageID=="top"){
            /* ---------------------------------------------

             -- [ ページトップの表示 ]

            --------------------------------------------- */
            if( this.offset.pagetop.start < inc && this.offset.pagetop.end > inc ){

                if(!this.status.pagetop){
                    this.status.pagetop = true;
                    TweenMax.to(this.$pageTop,0.48,{
                        x:0
                    });
                }
            }else{
                if(this.status.pagetop){
                    this.status.pagetop = false;
                    TweenMax.to(this.$pageTop,0.48,{
                        x:100
                    });
                }
            }

            if( 10<inc ){
                this.$root.classList.add("is-sc-start");
                this.$header.classList.add("is-white");

                if(this.status.sideBtn){
                    this.status.sideBtn = false;
                    TweenLite.to(this.$topKvSns,0.48,{
                        x:-300
                    });
                    TweenLite.to(this.$sideBtn,0.48,{
                        x:300
                    });
                    TweenLite.to(this.$scrollDown,0.48,{
                        y:100,
                        opacity:0
                    });
                }
            }else{
                this.$root.classList.remove("is-sc-start");
                this.$header.classList.remove("is-white");
                if(!this.status.sideBtn){
                    this.status.sideBtn = true;
                    TweenLite.killTweensOf(this.$scrollDown,{
                        y:true,
                        opacity:true
                    })
                    TweenLite.to(this.$topKvSns,0.48,{
                        x:0
                    });
                    TweenLite.to(this.$sideBtn,0.48,{
                        x:0
                    });
                    TweenLite.to(this.$scrollDown,0.48,{
                        y:0,
                        opacity:1
                    });
                }
            }



        }else{

            if( 10<inc ){
                this.$header.classList.add("is-white");
            }else{
                this.$header.classList.remove("is-white");
            }

        }

        if(bannerShow){
            let _banner = document.getElementById("c-android-banner");
            if( 10<inc ){
                TweenMax.to(['#l-header','#l-header-navi','#l-kv'], 0.3 ,{
                    top:''
                });
            }else{
                TweenMax.to(['#l-header','#l-header-navi'], 0.3 ,{
                    top:_banner.clientHeight
                });
                TweenMax.to('#l-kv', {
                    top:_banner.clientHeight/2
                });
            }
        }


    }
    resize (winH) {
        this.h = winH;
        let rect =  this.$footer.getBoundingClientRect();


        this.offset.scrollDown = rect.top-this.h;
        this.offset.pagetop = {
            start : this.h,
            end   : this.offset.scrollDown
        };


    }
}
